// Status & priority metadata + helpers (Spanish)

export const STATUS_META = {
  pendiente: {
    label: "Pendiente",
    dot: "bg-yellow-500",
    badge: "bg-yellow-100 text-yellow-800 border-yellow-200",
    leftBorder: "border-l-yellow-500",
    text: "text-yellow-600",
  },
  en_progreso: {
    label: "En progreso",
    dot: "bg-blue-500",
    badge: "bg-blue-100 text-blue-800 border-blue-200",
    leftBorder: "border-l-blue-500",
    text: "text-blue-600",
  },
  completada: {
    label: "Completada",
    dot: "bg-emerald-500",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
    leftBorder: "border-l-emerald-500",
    text: "text-emerald-600",
  },
  en_revision: {
    label: "En revisión",
    dot: "bg-indigo-500",
    badge: "bg-indigo-100 text-indigo-800 border-indigo-200",
    leftBorder: "border-l-indigo-500",
    text: "text-indigo-600",
  },
  vencida: {
    label: "Vencida",
    dot: "bg-red-500",
    badge: "bg-red-100 text-red-800 border-red-200",
    leftBorder: "border-l-red-500",
    text: "text-red-600",
  },
};

export const PRIORITY_META = {
  normal: { label: "Normal", badge: "bg-slate-100 text-slate-600 border-slate-200" },
  alta: { label: "Alta", badge: "bg-orange-100 text-orange-700 border-orange-200" },
  urgente: { label: "Urgente", badge: "bg-red-100 text-red-700 border-red-200" },
};

export const RECURRENCE_LABELS = {
  none: "Sin repetición",
  daily: "Diaria",
  weekly: "Semanal",
  monthly: "Mensual",
  custom: "Personalizada",
};

export const HISTORY_LABELS = {
  creada: "Creada",
  asignada: "Asignada",
  reasignada: "Reasignada",
  modificada: "Modificada",
  vista: "Vista por funcionario",
  iniciada: "Iniciada",
  evidencia: "Evidencia adjuntada",
  completada: "Completada",
  enviada_revision: "Enviada a revisión",
  aprobada: "Aprobada",
  rechazada: "Rechazada",
};

export function complianceColor(pct) {
  if (pct >= 90) return { key: "verde", bar: "bg-emerald-500", text: "text-emerald-600", bg: "bg-emerald-50", ring: "ring-emerald-200", label: "Excelente" };
  if (pct >= 80) return { key: "azul", bar: "bg-blue-500", text: "text-blue-600", bg: "bg-blue-50", ring: "ring-blue-200", label: "Bueno" };
  if (pct >= 70) return { key: "amarillo", bar: "bg-yellow-500", text: "text-yellow-600", bg: "bg-yellow-50", ring: "ring-yellow-200", label: "Regular" };
  return { key: "rojo", bar: "bg-red-500", text: "text-red-600", bg: "bg-red-50", ring: "ring-red-200", label: "Bajo" };
}

export function fmtDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("es", { weekday: "short", day: "2-digit", month: "short" });
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("es", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("es", { hour: "2-digit", minute: "2-digit" });
}

export const todayISO = () => new Date().toISOString().slice(0, 10);
